module.exports = __webpack_public_path__ + "img/circle-ok.98c9d711.svg";